import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import { withTranslation } from 'react-i18next';
import { BoardContainerProps, Board } from "../types/board.types";
import { type WithTranslation } from '../types/common.types';
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import SidePanel from '../components/sidePanel/sidePanel';
import * as SharedBoardActions from '../../actions/shared_board.actions';
import * as BorderHeaderAction from '../actions/boardHeader.action';
import * as CAction from '../actions/column.actions';
import * as CardAction from '../actions/card.actions';
import FilterForm from '../components/filters';
import {uniqueArrayObject} from '../../utils/function';
import BoardTimeline from '../components/timeline';
import BoardConst from '../utils/constants/board';
import ColumnList from '../components/column/column-list';
import BoardHeader from '../components/header/board.header';
import ImgIconComp from '../../components/imgcomp';
import BoardService from '../services/board.service';
import { getFeatureFlag } from '../../apps/project-management/utils/getFeatureFlag';

const boardSevice = new BoardService();
import { updateWsGraphData } from '../utils/board';
import { isAiIdTemporary } from '../../apps/project-management/utils/isAiIdTemporary';

declare global {
  interface Window {
    isVnextPage: () => boolean;
  }
}

interface BoardContainerState {
  heightToSubtract: number;
  wsMarginRight: number;
  wsPaddingRight: number;
}
class BoardContainerComp extends Component<WithTranslation<Board>, BoardContainerState>{
  private timer: any
  constructor(props: WithTranslation<Board>){
    super(props);
    this.state = {
      heightToSubtract: 0,
      wsMarginRight: 20,
      wsPaddingRight: 60,
    }
    this.timer = null;
    this.initPendoVisitorReport = this.initPendoVisitorReport.bind(this);
  }

  componentDidMount() {
    this.initPendoVisitorReport();
    this.activeBoardLeftMenu();
    $(document).on("update_board_fav_data", {}, this.updateBoardFavData);
    $('#mySidenasSingleEdit').first().attr('style','padding-top:0px');
    this.fetchMissingRelationshipCounts();

    document.addEventListener("click", this.updateContainerWidth);
    window.addEventListener("resize", this.updateContainerWidth);
    this.updateContainerWidth();
    window.initWsRelationsComponent('ws-relationships-button-id-1', {
      id: this.props.board.boardDetails.tagId,
    });
    if ($('.board-details-wrapper').length) {
     this.setState({wsMarginRight : 200, wsPaddingRight: 20});
    }
  }
  componentWillUnmount() {
    $('#mySidenasSingleEdit').first().attr('style','padding-top:62px');
    document.removeEventListener("click", this.updateContainerWidth);
    window.removeEventListener("resize", this.updateContainerWidth);
  }

  componentDidUpdate(): void {
    this.fetchMissingRelationshipCounts();
  }

  initPendoVisitorReport() {
    if (this.props.board.fusDetail?.isPendoEnabled) {
      window.trackPendoVisitorReport?.();
    }
  }

  updateBoardFavData = (e:any, args:any) => {
    const { obj_id, updateStatus, data = {} } = args;
    const { actions } = this.props;
    if (updateStatus == 1) {
      const findItem = data.find((item:any) => item.obj_id === obj_id);
      if (findItem) {
        this.props.dispatch(BorderHeaderAction.AddBoardFavData(findItem));
      }
    } else if (updateStatus == 0) {
      this.props.dispatch(BorderHeaderAction.DelBoardFavData(data));
    }
  }

  activeBoardLeftMenu = () => {
    const board = this.props.board.boardDetails;
    if (typeof board.id !== "undefined" && board.id) {
      $(".wb-secondary-board-menu-li").each(function () {
        $(this).removeClass("active");
        if ($(this).attr("data-id") == board.id) {
          $(this).addClass("active");
        }
      });
    }
  }

  updateContainerWidth = () => {
    const { boardView = '' } = this.props.board;

    setTimeout(() => {
      const wsDetailEl = document.querySelector(".wsHeadingTable");
      const wsDetailHeight = wsDetailEl?.getBoundingClientRect()?.height || 40;

      // 65px is top nav height
      const vNext = window.isVnextPage();
      const activityView = boardView == BoardConst.BOARD_VIEW_ACTIVITY;
      const heightToSubtract = (vNext ? 4 : 0) + (activityView ? 105 : 53) + wsDetailHeight;

      if (heightToSubtract !== this.state.heightToSubtract) {
        this.setState(state => ({
          ...state,
          heightToSubtract
        }));
      }
    }, 0);
  }

  boardScrollFn = (event: any) => {
    let self = this;
    const boardSectionEl: any = document.querySelector(".boardSection");
    // const leftPos =
    let containerWidth = boardSectionEl.offsetWidth;
    let leftPos = boardSectionEl.getBoundingClientRect().left + window.scrollX;
    let edgeGutter = 40;
    let scrollWidth = Math.max(
      boardSectionEl.scrollWidth,
      boardSectionEl.offsetWidth,
      boardSectionEl.clientWidth,
    );

    //Scroll right
    if(event.offsetX > (containerWidth - 200) ){
      if(event.offsetX > (containerWidth - 100)){
        boardSectionEl.scrollLeft = boardSectionEl.scrollLeft + 50;
        // boardSectionEl.scrollLeft = boardSectionEl.scrollWidth;
      }else{
        boardSectionEl.scrollLeft = boardSectionEl.scrollLeft + 20;
      }
      console.log('if');
    }
    //Scroll Left
    if(event.offsetX < 200 && boardSectionEl.scrollLeft !== 0){
      if(event.offsetX <= 40){
        boardSectionEl.scrollLeft = boardSectionEl.scrollLeft - 50;
        // boardSectionEl.scrollLeft = 0;
      }else{
        boardSectionEl.scrollLeft = boardSectionEl.scrollLeft - 20;
      }
    }
  }

  onBeforeCapture = (a: any, b: any) => {
    console.log('onBeforeCapture', a, b);
  }

  onDragEnd = (result: any) => {
    const { destination, source, draggableId, type } = result;
    this.timer = null;

    // Dropped outside any droppable — nothing to reorder.
    if (!destination) {
      return;
    }

    if (destination.droppableId === source.droppableId) {
      if (type === "COLUMN") {
        // column moved
        this.props.dispatch(CAction.sortingBoardColumn(source, destination, draggableId, 'column'));

      } else {
        // item move inside the same column
        this.props.dispatch(CAction.sortingBoardColumn(source, destination, draggableId,  'column_item'));
      }

    } else {
      // item move between columns
      this.props.dispatch(CAction.sortingBoardColumn(source, destination, draggableId, 'column_move_item'));
    }

    updateWsGraphData(this.props.board.boardDetails.tagId);
  }

  getOwnerLists = (columns: any) => {
    let owners: any = [];
    if (
      typeof columns !== "undefined" &&
      Array.isArray(columns)
    ) {
      columns.map((d: any) => {
         if (d.data) {
          owners = owners.concat(...d.data.map((d: any) => ({
            id: d.owner,
            fullName: `${d.owner_firstname} ${d.owner_lastname}`
          })))
         }
      });
    }
    return owners.length ? uniqueArrayObject(owners, 'id') : [];
  }

  getTagLists = (columns: any) => {
    let tags: any = [];
    if (typeof columns !== 'undefined' && Array.isArray(columns)) {
      columns.forEach((col: any) => {
        if (col.data) {
          col.data.forEach((item: any) => {
            if (Array.isArray(item.aiTags)) {
              tags = tags.concat(item.aiTags.map((tag: any) => ({
                tagId: tag.id,
                name: tag.name,
                label: tag.name,
                type: tag.type,
              })));
            }
          });
        }
      });
    }
    return tags.length ? uniqueArrayObject(tags, 'tagId') : [];
  }

  addBoardColum =  () => {
    this.props.dispatch(CAction.addBoardColumn());
    let scrollLength = $(".boardSection").width()+ 1000;
    console.log("scrollLength", scrollLength);
    $('.mainBoardWrapper').animate( { scrollLeft: scrollLength }, 200);
  }

  fetchMissingRelationshipCounts = () => {
    if (!getFeatureFlag('pmAIRelationshipsEnabled')) return;
    const idsMissingCounts = [];
    this.props.board.boardDetails.columns.forEach(
      col => col.data?.forEach((item) => {
        if (typeof item.relationshipsCount === "undefined" && !isAiIdTemporary(item.id)) {
          idsMissingCounts.push(item.id);
        }
      })
    );
    if (idsMissingCounts.length > 0) {
      this.props.dispatch(
        CardAction.updateRelationshipCounts({
          requestedIds: idsMissingCounts,
          counts: []
        })
      );
      boardSevice.getRelationshipsCount({ids: idsMissingCounts}).then(result => {
        this.props.dispatch(
          CardAction.updateRelationshipCounts({
            requestedIds: idsMissingCounts,
            counts: result?.data?.data || 0
          })
        );
      });
    }
  }

  render() {
    const { t } = this.props;
    //default board background color
    const defaultBoardBGcolor = '#eceff2';
    const { boardDetails, boardFilters, boardView = '' } = this.props.board;
    const {wsPermissions, userPermission, boardType, columns,
      boardSettings} = boardDetails;
    let cardType = BoardConst.BOARD_DATATYPE_ACTIONS;
    if (boardDetails.board) {
      cardType = boardDetails.board.type;
    }
    const {is_co_manager, is_manager, is_team_admin } = wsPermissions || {};
    const {editBoard} = userPermission || {};
    const isAdminPermission: boolean = (is_co_manager || is_manager || is_team_admin || editBoard == "1");
    const isCustomBoard: boolean = (boardType == BoardConst.WS_BOARD_TYPE_CUSTOM);
    if (isAdminPermission && isCustomBoard && !columns.length) {
      this.props.dispatch(CAction.addBoardColumn());
    }
    const findNewColumn = columns.find((c: any) => CAction.isNewColumnId(c.id));
    const isNewCol: boolean = (isCustomBoard && findNewColumn && typeof findNewColumn.id !== undefined);
    const isAddColumnButton: boolean = (!isNewCol && isAdminPermission && isCustomBoard);

    let boardStyle: any = {};
    const {theme} = boardSettings || {};
    if (theme) {
      if (theme.themeColor || theme.themeName) {
        const bgColor = theme.themeColor ? theme.themeColor
          : (theme.themeName == 'default' ? defaultBoardBGcolor : theme.themeName);
        boardStyle.backgroundColor = bgColor;
        //boardStyle.borderTop= `10px solid ${bgColor}`;
      }
      if (theme.themeImg) {
        boardStyle.backgroundImage = `url(${theme.themeImg})`;
        // boardStyle.borderTop= `10px solid rgba(0,0,0,0.1)`;
        // boardStyle.backgroundClip =  "border-box";
      }
    }
    else {
      boardStyle.backgroundColor = defaultBoardBGcolor;
    }

    boardStyle.height = `calc(100vh - ${this.state.heightToSubtract}px - 65px)`;

    //console.log(this.props);
    let aiOwnerLists: any = [];
    let aiTagLists: any = [];
    if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
      aiOwnerLists = this.getOwnerLists(boardDetails.columns);
      aiTagLists = this.getTagLists(boardDetails.columns);
    }
    const wsMarginRight = this.state.wsMarginRight;
    const wsPaddingRight = this.state.wsPaddingRight;
    const showVisualBoardHeader = (boardView == BoardConst.BOARD_VIEW_SHARED) && Object.keys(boardDetails.board).length > 0;
    return (
      <>
        <input type="hidden" value="0" id="fromMainAIPopup"/>
        {(boardView == BoardConst.BOARD_VIEW_ACTIVITY) && <>
          <div id="board-filters">
            <FilterForm
              boardType={boardType}
              {...boardFilters}
              ownerLists={aiOwnerLists}
              tagLists={aiTagLists}
            />
          </div>
          <div className='workstream-relationship-wrapper' style={{
                float: 'right',
                marginRight: `${wsMarginRight}px`,
                paddingRight: `${wsPaddingRight}px`,
          }
          }>
            <div id="ws-relationships-button-id-1" className='workstream-relationship-button' style={{
              position: 'absolute',
              float: 'right'}}/>
          </div>
          <BoardTimeline {...this.props.board}/>
         <div className="clear"></div>
        </>}
        {showVisualBoardHeader && <BoardHeader boardDetails={boardDetails}/>}
        <div className="mainBoardContainer" style={boardStyle}>
          <div className={`mainBoardWrapper ${boardDetails.viewAiPane ? 'viewAiPane' : ''}`}
            data-card-type={cardType}
           >
            <div className="mainBoardWrapper__inner">

            <DragDropContext
            onBeforeCapture={this.onBeforeCapture}
            onDragEnd={this.onDragEnd}
            >
              <Droppable
                droppableId="board"
                type="COLUMN"
                direction="horizontal"
              >
                {
                  (dProvided: any) => (
                    <div className="boardSection" ref={dProvided.innerRef} {...dProvided.droppableProps} >
                      {
                        <ColumnList {...this.props} />
                      }
                      {dProvided.placeholder}
                    </div>
                  )
                }
              </Droppable>
            </DragDropContext>
              {isAddColumnButton && (
                <div className='board-add-button-wrapper'>
                  <div
                    className='board-add-column-button'
                    id='board-add-column-button'
                    onClick={this.addBoardColum}
                    data-tip={t('Add Column')}
                  >
                    <ImgIconComp
                      id="add_column"
                      width="20"
                      height="20"
                    />
                  </div>
                  <ReactTooltip />
                </div>
              )}
            </div>

          </div>
          {
            boardDetails.viewAiPane && boardDetails.viewAiPane.id &&
            <SidePanel key={boardDetails.viewAiPane.id} {...this.props} />
          }
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: BoardContainerProps) => ({
  board: state
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  actions: bindActionCreators(SharedBoardActions, dispatch),
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BoardContainerComp));
